var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconButton',{attrs:{"color":"secondary","loading":_vm.loading,"icon":"mdi-email"},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.$t('send_invoice'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }